import dynamic from "next/dynamic";
import { multiplierForMetric, unitForMetric } from "./components/charts/common/utils";
import { CollectionProvider } from "./context/CollectionContext";
import { useCollectionTutorialsState } from "./context/CollectionTutorialContext";
import { getThresholdsFromMetadata, isAnomalyManagementApplied, isDefenceApplied, isPointAnomalyManagamentApplied, isPointDefenceApplied } from "./metadata/utils";
import { AnalysisMetadata, CollectionAsset, PointDetailsPermissions } from "./types";
import { getExposureStatus } from "./utils";
const DownloadMetadataButton = dynamic(() => import("./metadata/DownloadMetadataButton"), {
  ssr: false
});
export { CollectionRoute } from "./components/CollectionRoute";
export { useAnalysisSettings } from "./hooks/useAnalysisSettings";
export { useAnalysisViewRoute } from "./hooks/useAnalysisViewRoute";
export { useAdaptedSummaryStatus } from "./hooks/useSummaryStatus";
export { CollectionProvider, DownloadMetadataButton, getExposureStatus, getThresholdsFromMetadata, isAnomalyManagementApplied, isDefenceApplied, isPointAnomalyManagamentApplied, isPointDefenceApplied, multiplierForMetric, unitForMetric, useCollectionTutorialsState };
export type { AnalysisMetadata, CollectionAsset, PointDetailsPermissions };
export { MAX_YEAR, MIN_YEAR, YEAR_STEP } from "./constants";